import { useState } from "react";
import api, { apiErr } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Trash2, UserPlus, Wrench, HardHat } from "lucide-react";
import { toast } from "sonner";
import { Field, NSelect, TInput } from "@/components/technique/fields";

const empty = { kind: "artisan", ref_id: "", task_id: "", equipe: "", role: "" };

export default function TechAssignments({ data, artisans, workers, reload, only }) {
  const [f, setF] = useState({ ...empty, kind: only || "artisan" });
  const list = data.assignments.filter((a) => !only || a.kind === only);
  const set = (k) => (v) => setF({ ...f, [k]: v, ...(k === "kind" ? { ref_id: "" } : {}) });
  const refs = (f.kind === "artisan" ? artisans : workers).filter((r) => r.statut !== "Inactif")
    .map((r) => ({ value: r.id, label: `${r.nom}${r.specialite ? ` · ${r.specialite}` : ""}` }));
  const add = async () => {
    try { await api.post(`/technique/files/${data.file.id}/assignments`, f); toast.success("Affectation créée"); setF({ ...empty, kind: f.kind }); reload(); }
    catch (e) { toast.error(apiErr(e)); }
  };
  const del = async (a) => { await api.delete(`/technique/assignments/${a.id}`); reload(); };
  return (
    <div className="space-y-4">
      <div className="rounded-lg border bg-white p-4 grid sm:grid-cols-2 lg:grid-cols-6 gap-3 items-end">
        {!only && <Field label="Type"><NSelect value={f.kind} onChange={set("kind")} placeholder="Type" options={[{ value: "artisan", label: "Artisan" }, { value: "ouvrier", label: "Ouvrier" }]} testid="tech-as-kind" /></Field>}
        <Field label={f.kind === "artisan" ? "Artisan (base existante)" : "Ouvrier (base existante)"} className="lg:col-span-2"><NSelect value={f.ref_id} onChange={set("ref_id")} placeholder="Rechercher…" options={refs} testid="tech-as-ref" /></Field>
        <Field label="Tâche"><NSelect value={f.task_id} onChange={set("task_id")} placeholder="Chantier (général)" options={data.tasks.map((t) => ({ value: t.id, label: t.titre }))} testid="tech-as-task" /></Field>
        <Field label="Équipe"><TInput value={f.equipe} onChange={set("equipe")} placeholder="Ex. Équipe A" testid="tech-as-equipe" /></Field>
        <Button disabled={!f.ref_id} onClick={add} data-testid="tech-as-add" className="bg-brand-600 hover:bg-brand-700 text-white"><UserPlus className="h-4 w-4 mr-1" />Affecter</Button>
      </div>
      <div className="rounded-lg border bg-white overflow-hidden">
        {list.length === 0 ? <p className="px-4 py-3 text-sm text-slate-400">Aucune affectation.</p> : (
          <div className="divide-y">
            {list.map((a) => (
              <div key={a.id} className="flex items-center gap-3 px-4 py-2.5 text-sm flex-wrap" data-testid={`tech-as-row-${a.id}`}>
                {a.kind === "artisan" ? <Wrench className="h-4 w-4 text-amber-600" /> : <HardHat className="h-4 w-4 text-brand-600" />}
                <div className="flex-1 min-w-[160px]"><p className="font-medium">{a.ref_name}</p><p className="text-xs text-slate-400">{a.kind === "artisan" ? "Artisan" : "Ouvrier"}{a.specialite ? ` · ${a.specialite}` : ""}{a.telephone ? ` · ${a.telephone}` : ""}</p></div>
                {a.equipe && <span className="text-xs rounded-full bg-slate-100 px-2 py-0.5">{a.equipe}</span>}
                <span className="text-xs text-slate-600">{a.task_titre || "Chantier (général)"}</span>
                <Button size="icon" variant="ghost" className="text-rose-600" onClick={() => del(a)} data-testid={`tech-as-del-${a.id}`}><Trash2 className="h-4 w-4" /></Button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
